import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class notaVentaService {


    /******* QUERIES ******/
    async listarEstado() {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/estado`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };    

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };    


    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket58(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/pdf-ticket-50?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async importarRegistrados(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/importar-registrados?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async datosIniciales(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/datos-iniciales?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ver(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/ver?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async notaVnetaVinculado(filter) {
        const response = await axios
            .get(`${ERP}ventas/nota-venta/nota-referencia?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}ventas/nota-venta`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}ventas/nota-venta`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async anular(data) {
        const response = await axios
            .put(`${ERP}ventas/nota-venta/anular`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async aprobar(data) {
        const response = await axios
            .put(`${ERP}ventas/nota-venta/aprobar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async enviarCorreo(data) {
        const response = await axios
            .put(`${ERP}ventas/nota-venta/enviar-correo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new notaVentaService();